/** Former UI defaults that are no longer built-in group options. */
export const RETIRED_DEFAULT_GROUPS = [
  'Balcony',
  'Large room',
  'A/C unit',
  'Fridge',
  'Family OK',
] as const;

const retiredSet = new Set(
  RETIRED_DEFAULT_GROUPS.map((n) => n.toLowerCase()),
);

export const isRetiredDefaultGroup = (name: string | null | undefined) => (
  Boolean(name) && retiredSet.has(String(name).trim().toLowerCase())
);

export const filterRetiredDefaultGroups = (list: string[] | null | undefined) => {
  if (!Array.isArray(list)) return [];
  return list.filter((n) => !isRetiredDefaultGroup(n));
};
